import { ApolloClient, ApolloLink, concat, HttpLink, InMemoryCache } from '@apollo/client'
import { SupportedChainId } from 'constants/chains'

import store from '../../state/index'

const ONE_SUBGRAPH_URL_FOR_ALL = process.env.REACT_APP_THE_GRAPH_SCHEMA_ENDPOINT as string

const CHAIN_SUBGRAPH_URL: Record<number, string> = {
  [SupportedChainId.DUCX]: ONE_SUBGRAPH_URL_FOR_ALL,
  [SupportedChainId.DUCX_TESTNET]: ONE_SUBGRAPH_URL_FOR_ALL,
}

const httpLink = new HttpLink({ uri: process.env.REACT_APP_THE_GRAPH_SCHEMA_ENDPOINT })

// This middleware will allow us to dynamically update the uri for the requests based off chainId
// For more information: https://www.apollographql.com/docs/react/networking/advanced-http-networking/
const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  const chainId = store.getState().application.chainId

  operation.setContext(() => ({
    uri:
      chainId && CHAIN_SUBGRAPH_URL[chainId] ? CHAIN_SUBGRAPH_URL[chainId] : CHAIN_SUBGRAPH_URL[SupportedChainId.DUCX],
  }))

  return forward(operation)
})

export const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: concat(authMiddleware, httpLink),
})
